import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { HeroNoShave } from "@/components/site/HeroNoShave";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { NoShaveFacts } from "@/components/site/NoShaveFacts";
import { Footer } from "@/components/site/Footer";
import { NOSHAVE, NOSHAVE_FAQ } from "@/lib/wp-restore/no-shave";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));

const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/no-shave-fue-hair-transplant")({
  head: () => ({
    meta: [
      { title: NOSHAVE.meta.title },
      { name: "description", content: NOSHAVE.meta.description },
      { property: "og:title", content: "No-Shave FUE Hair Transplant | RESTORE® Hair Transplants" },
      {
        property: "og:description",
        content:
          "Discover the most discreet hair restoration procedure with RESTORE® No-Shave FUE™. No shaved donor area. Natural, undetectable results.",
      },
      { property: "og:url", content: "https://restorehair.com/no-shave-fue-hair-transplant/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/no-shave-fue-hair-transplant/" }],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <HeroNoShave />
        <NorwoodQuiz />
        <Suspense fallback={null}>
          <NoShaveFuture wpCopy={NOSHAVE.future} />
          <NoShaveWhy wpCopy={NOSHAVE.why} />
          <Results hideEyebrowMobile showDisclaimer nameTag="h2" />
          <NoShaveFacts />
          <Guarantee backgroundColor="#ffffff" wpCopy={NOSHAVE.guarantee} />
          <VirtualConsult heading={<>Schedule Your<br />Complimentary Consultation Today</>} />
          <Faq items={NOSHAVE_FAQ} numbered headingTag="h3" questionTag="h4" preHeading={NOSHAVE.faqPre} />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
